import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=1953ee22&"
import script from "./MyAccount.vue?vue&type=script&lang=ts&"
export * from "./MyAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports